<template>
  <div class="row">
    <div class="col-lg-12">
      <div
        v-if="isLoading"
        class="alert alert-info"
        role="status">{{$t('alerts.loading')}}...</div>
      <div
        v-if="error"
        class="alert alert-danger"
        role="alert">
        <span
          class="fa fa-exclamation-triangle"
          aria-hidden="true" ></span> {{ error }}
      </div>
      <div
        v-if="deleteError"
        class="alert alert-danger"
        role="alert">
        <span
          class="fa fa-exclamation-triangle"
          aria-hidden="true" ></span> {{ deleteError }}
      </div>
    </div>
    <b-col cols="lg-12">
      <b-card no-body>
        <b-tabs card v-model="tabIndex">
          <b-tab :title="$t('views.excmtasktype.show.title')">
            <div
              v-if="item"
              class="table-responsive">
              <table class="table table-striped table-hover">
                <thead>
                <tr>
                  <th>Field</th>
                  <th>Value</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>title</td>
                  <td>{{ item['title'] }}</td>
                </tr>
                <tr>
                  <td>subtitle</td>
                  <td>{{ item['subtitle'] }}</td>
                </tr>
                <tr>
                  <td>desc2tooltip</td>
                  <td>{{ item['desc2tooltip'] }}</td>
                </tr>
                <tr>
                  <td>duration</td>
                  <td>{{ item['duration'] }}</td>
                </tr>
                <tr>
                  <td>groups</td>
                  <td>{{ item['groups'] }}</td>
                </tr>
                <tr>
                  <td>notification</td>
                  <td>{{ item['notification'] }}</td>
                </tr>
                <tr>
                  <td>notificationEnable</td>
                  <td>{{ item['notificationEnable'] }}</td>
                </tr>
                <tr>
                  <td>notificationTitle</td>
                  <td>{{ item['notificationTitle'] }}</td>
                </tr>
                <tr>
                  <td>notificationContent</td>
                  <td>{{ item['notificationContent'] }}</td>
                </tr>
                <tr>
                  <td>alarm</td>
                  <td>{{ item['alarm'] }}</td>
                </tr>
                <tr>
                  <td>alarmEnable</td>
                  <td>{{ item['alarmEnable'] }}</td>
                </tr>
                <tr>
                  <td>alarmTitle</td>
                  <td>{{ item['alarmTitle'] }}</td>
                </tr>
                <tr>
                  <td>alarmContent</td>
                  <td>{{ item['alarmContent'] }}</td>
                </tr>
                <tr>
                  <td>idDefaultNextTask</td>
                  <td>{{ item['idDefaultNextTask'] }}</td>
                </tr>
                <tr>
                  <td>idCasesType</td>
                  <td>{{ item['idCasesType'] }}</td>
                </tr>
                <tr>
                  <td>conditionsAdd</td>
                  <td>{{ item['conditionsAdd'] }}</td>
                </tr>
                <tr>
                  <td>fieldReadonly</td>
                  <td>{{ item['fieldReadonly'] }}</td>
                </tr>
                <tr>
                  <td>dfeCase</td>
                  <td>{{ item['dfeCase'] }}</td>
                </tr>
                <tr>
                  <td>dfeReason</td>
                  <td>{{ item['dfeReason'] }}</td>
                </tr>
                <tr>
                  <td>runCustom</td>
                  <td>{{ item['runCustom'] }}</td>
                </tr>
                <tr>
                  <td>infoaboutnew</td>
                  <td>{{ item['infoaboutnew'] }}</td>
                </tr>
                <tr>
                  <td>infoaboutnewContent</td>
                  <td>{{ item['infoaboutnewContent'] }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <router-link
              v-if="item"
              :to="{ name: 'EXCMTaskTypeList' }"
              class="btn btn-default">{{$t('buttons.backToList')}}</router-link>
            <button
              class="btn btn-danger"
              @click="deleteItem(item)">{{$t('buttons.delete')}}</button>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'

export default {
  beforeCreate () {
    checkPagePermission('configuration', 'EXCMTaskTypeShow')
  },

  computed: mapGetters({
    deleteError: 'excmtasktype/del/error',
    error: 'excmtasktype/show/error',
    isLoading: 'excmtasktype/show/isLoading',
    item: 'excmtasktype/show/retrieved'
  }),

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'excmtasktype/del/del',
      reset: 'excmtasktype/show/reset',
      retrieve: 'excmtasktype/show/retrieve'
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXCMTaskTypeList' }))
      }
    }
  }
}
</script>
